import tokens from "@calcom/config/theme/miragon/cd-tokens.generated.json";

/**
 * Miragon's colors for places that cannot use the CSS roles of packages/config/theme/miragon (e-mails, the
 * browser's theme color). They come from the token file vendored from Miragon/corporate-identity, so no value is
 * typed here (Miragon fork, see FORK_CHANGES.md).
 */
export const MIRAGON_LIGHT = tokens.hell;
export const MIRAGON_DARK = tokens.dunkel;
export const MIRAGON_FIXED = tokens.fest;

// Miragon's word mark and comet as shapes, taken unchanged from Miragon/corporate-identity
// (docs/public/logo/miragon-logo-*.svg, miragon-komet-*.svg; the copies in apps/web/public must stay identical).
export const MIRAGON_WORDMARK_VIEWBOX = "0 0 316.05 48.42";
export const MIRAGON_WORDMARK_SHAPES: ReadonlyArray<{ type: "path" | "polygon"; value: string }> = [
  {
    type: "path",
    value:
      "M159.09,.19h-12.45l-26.42,47.47h12.15l5.01-9.2h17l1.67,9.2h12.07L159.09,.19Zm-16.17,28.07l7.36-13.38,2.35,13.38h-9.72Z",
  },
  {
    type: "polygon",
    value:
      "43.54 .76 28.11 30.17 22.91 .76 8.25 .76 0 47.66 11.46 47.66 16.42 19.78 21.31 47.66 29.25 47.66 43.92 19.78 38.95 47.66 50.49 47.66 58.73 .76 43.54 .76",
  },
  {
    type: "path",
    value:
      "M195.3,31.77h7.1c-1.3,3.44-4.74,5.88-9.09,5.88-5.8,0-9.32-4.35-9.32-10.85,0-9.32,4.81-16.04,12.14-16.04,4.2,0,6.87,2.21,7.56,5.65h12.22c-.69-9.47-7.64-16.42-19.4-16.42-14.51,0-24.9,12.22-24.9,27.11,0,12.53,8.25,21.31,21.31,21.31,11.69,0,20.32-7.94,22.23-19.17l1.15-6.64h-19.4l-1.6,9.17Z",
  },
  {
    type: "path",
    value:
      "M244.48,0c-13.98,0-24.9,11.46-24.9,27.11,0,12.45,8.1,21.31,21.08,21.31,13.98,0,24.9-11.46,24.9-27.11,0-12.45-8.1-21.31-21.08-21.31Zm-3.44,37.65c-5.58,0-9.09-4.51-9.09-10.85,0-9.93,5.27-16.04,12.14-16.04,5.58,0,9.09,4.51,9.09,10.85,0,9.93-5.35,16.04-12.14,16.04Z",
  },
  {
    type: "polygon",
    value:
      "304.21 .76 299.48 27.42 285.8 .76 274.8 .76 266.56 47.66 278.39 47.66 283.36 19.4 298.33 47.66 307.8 47.66 316.05 .76 304.21 .76",
  },
  { type: "path", value: "M58.66,47.66h12.3l4.61-26.2c-6.24-.26-11.22-.5-12.2-.55l-4.71,26.75Z" },
  { type: "polygon", value: "66.91 .76 63.38 20.84 76.33 17.08 79.2 .76 66.91 .76" },
  {
    type: "path",
    value:
      "M122.66,14.51c0-8.71-5.73-13.75-14.97-13.75h-20.24l-2.43,13.79,14.07-4.09s6.05-1.92,8.69-.96c7.11,2.59,4.56,11.64-3.08,12.51-2.65,.3-11.87,.08-20.95-.25l-4.55,25.89h12.14l2.75-15.5h4.66l7.48,15.5h12.98l-8.48-16.8c6.95-2.37,11.91-7.94,11.91-16.34Z",
  },
];
// The comet's own box is about 288 × 90; the app icon places it at translate(66 196.9) scale(1.31908).
export const MIRAGON_KOMET_PATH =
  "M0,89.63l220.2-14.78c11.65-.78,23.38-2.66,33.31-5.14s22.92-8.94,29.16-19.41c3.65-6.12,5.09-13.73,5.38-18.91,.27-4.94-.99-10.2-2.54-13.33-2.76-5.55-6.11-8.42-8.55-10.26-2.45-1.84-7.55-5.77-18.08-7.35-10.53-1.58-29.62,1.2-44.31,5.84C199.87,10.92,0,89.63,0,89.63Z";

// Miragon's imprint, linked next to the privacy policy wherever the app names its operator
export const MIRAGON_IMPRINT_URL = "https://www.miragon.io/impressum/";
export const MIRAGON_WEBSITE_URL = "https://www.miragon.io/";
